'use client';

import React from 'react';
import { Select } from 'antd';
import { CaretDown } from '@phosphor-icons/react';
import { ButtonCommon } from '../Button/ButtonCommon';
// import { useMediaQuery } from 'react-responsive';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { ReportFilterHeaderProps } from 'types/common';
const { RangePicker } = DatePicker;

const ReportFilterHeader: React.FC<ReportFilterHeaderProps> = ({
  reportTypes = [
    { value: 'orders', label: 'Đơn hàng' },
    { value: 'revenue', label: 'Doanh thu' },
  ],
  selectedReportType = 'orders',
  onReportTypeChange,
  // onExportData,
  onApplyFilter,
  onClearFilter,
  className = '',
  selectedDateRangeValue,
  onDateRangeValueChange,
}) => {
  // const isDesktop = useMediaQuery({ minWidth: 1024 });
  const datePresets = [
    {
      label: 'Hôm qua',
      value: (): [dayjs.Dayjs, dayjs.Dayjs] => [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    },
    { label: '7 ngày trước', value: (): [dayjs.Dayjs, dayjs.Dayjs] => [dayjs().subtract(6, 'day'), dayjs()] },
    { label: '14 ngày trước', value: (): [dayjs.Dayjs, dayjs.Dayjs] => [dayjs().subtract(13, 'day'), dayjs()] },
    { label: '30 ngày trước', value: (): [dayjs.Dayjs, dayjs.Dayjs] => [dayjs().subtract(29, 'day'), dayjs()] },
    { label: '90 ngày trước', value: (): [dayjs.Dayjs, dayjs.Dayjs] => [dayjs().subtract(89, 'day'), dayjs()] },
  ];

  return (
    <div className={`w-full lg:px-6 px-0 py-4 rounded-2xl bg-white border border-gray-100 ${className}`}>
      <div className='px-4 flex justify-between items-center  lg:gap-6 gap-3'>
        {/* Left section - Filters */}
        <div className='flex-1 flex items-center lg:gap-6 gap-3'>
          <div className='flex items-center lg:gap-4 gap-2'>
            {/* Report Type Label */}
            <span className='text-gray-900 text-base font-normal font-Inter'>Báo cáo:</span>

            {/* Report Type Select */}
            <Select
              value={selectedReportType}
              onChange={onReportTypeChange}
              options={reportTypes}
              className='2xl:w-96 xl:w-80 md:w-40  w-35'
              size='large'
              style={{
                height: '40px',
              }}
              suffixIcon={<CaretDown size={16} className='text-gray-900' />}
            />

            {/* Date Range Select */}
            <RangePicker
              value={selectedDateRangeValue}
              onChange={(dates) => {
                if (onDateRangeValueChange) {
                  if (dates && dates[0] && dates[1]) {
                    onDateRangeValueChange([dates[0], dates[1]]);
                  } else {
                    onDateRangeValueChange(null);
                  }
                }
              }}
              format='DD/MM/YYYY'
              allowClear
              presets={datePresets}
              className='2xl:w-96 xl:w-80 md:w-40 w-35'
              style={{ height: '40px' }}
              placeholder={['Từ ngày', 'Đến ngày']}
            />
          </div>
        </div>

        {/* Right section - Action buttons */}
        <div className='flex items-center gap-2'>
          {/* Export Data Button */}
          {/* <ButtonCommon
            color='soft'
            size='sm'
            radius='rounded'
            icon={isDesktop ? <Printer size={16} /> : null}
            iconPosition='left'
            onClick={onExportData}
          >
            Xuất Data
          </ButtonCommon> */}

          {/* Apply Filter Button */}
          <ButtonCommon color='primary' radius='rounded' size='sm' onClick={onApplyFilter}>
            Áp dụng
          </ButtonCommon>

          {/* Clear Filter Button */}
          <ButtonCommon
            color='none'
            className='!text-[var(--textBlack100)]'
            radius='rounded'
            size='sm'
            onClick={onClearFilter}
          >
            Xoá bộ lọc
          </ButtonCommon>
        </div>
      </div>
    </div>
  );
};

export default ReportFilterHeader;
